// extracted by mini-css-extract-plugin
export var container = "layout-module--container--1x_ZX";
export var content = "layout-module--content--15pGJ";